    <div
        class="scaffold-list-holder"
        [ngClass]="{'horizontal-list':item.is_horizontal,
        'horizontal-list-1':item.items && item.items.length == 1,
        'horizontal-list-2':item.items && item.items.length == 2,
        'no-wrap-list':item.prevent_wrap}">
    <div
        *ngFor="let el of item.items;
        let $i = index;
        let $last = last;"
        class="scaffold-list-item data-search-results data-array-item">
    <div class="data-content">
      <app-rendered
        [info]="info"
        *ngFor="let it of el"
        [paramprefix]="(prefix ? prefix : '') + item.name + '/' + $i"
        [item]="it"
        [arr]="el">
      </app-rendered>
    </div>
    <div class="delete-link"
         *ngIf="!item.prevent_edit && !checkDisable()">
      <p-button severity="info" variant="text"
         (click)="deletFromArray(item.name, item, 'datas', $i)"
         class="action-button">
        <span>
          <i
            class="fat fa-trash-alt"
            [title]="'delete'| translation">
          </i>
        </span>
      </p-button>

      <p-button severity="info" variant="text"
          (click)="addDataItem(item.name, item, 'datas')"
          *ngIf="$last && item.use_inline && !item.prevent_edit"
          class="action-button">

        <span>
          <i
            class="fas fa-plus-circle"
             [title]="item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform">
          </i>
        </span>
      </p-button>
    </div>
  </div>

        <div
            class="scaffold-create-button"
            [ngClass]="item.alignment"
            *ngIf="(!item.items || item?.items?.length == 0) && item.use_inline && !item.prevent_edit && !checkDisable()">
    <button pButton
            size="small"
            shape="round"
            class="use-icon-button"
            (click)="addDataItem(item.name, item, 'datas')"
            *ngIf="item.button_type == 'circle'">
      <span>
        <span
            *ngIf="item.use_icon"
            class="create-button-icon"
            style="font-size:2rem;">
          <i
            [ngClass]="item.icon">
          </i>
        </span>
        <span
            class="create-button-heading">
            {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
        </span>
      </span>
    </button>
    <p-button severity="info" variant="text"
            (click)="addDataItem(item.name, item, 'datas')"
            *ngIf="item.button_type == 'ghost'">
      <span
            *ngIf="item.use_icon"
            class="create-button-icon">
        <i
            [ngClass]="item.icon">
        </i>
      </span>
      <span
            class="create-button-heading">
            {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
      </span>
    </p-button>
    <button pButton
            class="use-icon-button"
            (click)="addDataItem(item.name, item, 'datas')"
            *ngIf="item.button_type != 'circle' && item.button_type != 'ghost'">
      <span
            *ngIf="item.use_icon"
            class="create-button-icon">
        <i
            [ngClass]="item.icon">
        </i>
      </span>
      <span
            class="create-button-heading">
            {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
      </span>
      </button>
    </div>
    </div>
        <div
            class="scaffold-create-button"
            [ngClass]="item.alignment"
            *ngIf="!item.prevent_edit && !item.use_inline && !checkDisable()">
        <button pButton
            size="small"
            [rounded]="true"
            class="use-icon-button"
            (click)="addDataItem(item.name, item, 'datas')"
            *ngIf="item.button_type == 'circle'">
        <span>
        <span
            *ngIf="item.use_icon"
            class="create-button-icon"
            style="font-size:2rem;">
        <i
            [ngClass]="item.icon">
        </i>
      </span>
      <span
            class="create-button-heading">
            {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
      </span>
    </span>
  </button>
  <p-button severity="info" variant="text"
          (click)="addDataItem(item.name, item, 'datas')"
          *ngIf="item.button_type == 'ghost'">

    <span
          *ngIf="item.use_icon"
          class="create-button-icon">
      <i
          [ngClass]="item.icon">
      </i>
    </span>
    <span 
          class="create-button-heading">
          {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
    </span>
  </p-button>
  <p-button severity="info" variant="text"
          class="use-icon-button"
          (click)="addDataItem(item.name, item, 'datas')"
          *ngIf="item.button_type != 'circle' && item.button_type != 'ghost'">

    <span
          *ngIf="item.use_icon"
          class="create-button-icon">
      <i
          [ngClass]="item.icon">
      </i>
    </span>
    <span
          class="create-button-heading">
          {{item.translation_key||item.add_label||'add_item'| translation|translationFromString | transformText :item?.text_transform}}
    </span>
  </p-button>
</div>
